import * as React from 'react'
import Container from '@mui/material/Container';
import GlobalStyles from "@mui/material/GlobalStyles/GlobalStyles";
import Typography from "@mui/material/Typography/Typography";
import TextField from "@mui/material/TextField/TextField";
import { Grid, MenuItem, Stack, Button } from '@mui/material';
import * as yup from 'yup';
import { Formik,Form } from 'formik';
import {AuthUserContext} from "../../providers/AuthProvider";
import {useNavigate} from "react-router-dom";
const MembershipPlanPaymentUSA = () => {
    function isNumber(evt) {
        evt = (evt) ? evt : window.event;
        var charCode = (evt.which) ? evt.which : evt.keyCode;
        if (charCode > 31 && (charCode < 48 || charCode > 57)) {
            return false;
        }
        return true;
    }
    let validate=  yup.object({
        name:yup.string('name').required('Name is required').min(3,'Name must contains of 3 characters').max(35,'name must contains of 35 character'),
        country: yup.string('country').required('Country required'),
        cardNumber: yup.number('cardNumber').required('Card number required').min(13,'Card number must be of 13 characters'),
        securityCode:yup.string('securityCode').required('Security code is required').min(3,'Security Code minimum 3 digits').max(4,'Security code maximum 4digits'),
        expirationDate:yup.string()
            .typeError('Not a valid expiration date. Example: MM/YY')
            .max(5, 'Not a valid expiration date. Example: MM/YY')
            .matches(
                /([0-9]{2})\/([0-9]{2})/,
                'Not a valid expiration date. Example: MM/YY'
            )
            .required('Expiration date is required'),
        address:yup.string('address').required('Address is required').min(3,'Address must contains of 3 characters').max(35,'Address must contains of 35 character')
    })

    const {profile}= React.useContext(AuthUserContext);
    const navigator = useNavigate();
    return ( 
    <Formik
            initialValues={{name: '',country: '',cardNumber: '', securityCode: '',expirationDate:'',address:''}}
            validationSchema={validate}
            onSubmit={values => {
                if(profile?.userType==='creator'){
                    navigator('/creator/additional-details')
                }else{
                    navigator('/investor/additional-details')
                }
            }
    }

        >
            {
                formik=>(
                    <Form onSubmit={formik.handleSubmit}>
                        <React.Fragment>
                            <GlobalStyles styles={{ ul: { margin: 0, padding: 0, listStyle: 'none' } }} />
                            {/* Hero unit */}
                            {/*<TopBar showBar={true}/>*/}
                            <Container maxWidth="fullWidth" sx={{backgroundColor: '#E3E8F0', paddingY: 8,  mb: 8, textAlign:'left'}}>
                                <Container maxWidth="lg">
                                    <Typography variant={'h4'} sx={{pl: 2}} color={'primary'}>
                                        PAYMENT
                                    </Typography>

                                </Container>

                            </Container>
                            <Container maxWidth="lg"  >
                                <Grid container spacing={5} >
                                    <Grid item xs={12}>
                                        <TextField
                                            label="Full Name*"
                                            sx={{width:"90%"}}
                                            name={'name'}
                                            value={formik.values.name}
                                            onChange={formik.handleChange}
                                            error={formik.touched.name && Boolean(formik.errors.name)}
                                            helperText={formik.touched.name && formik.errors.name}
                                        />
                                    </Grid>

                                    <Grid item xs={12}>

                                        <TextField
                                            select
                                            name={'country'}
                                            value={formik.values.country}
                                            onChange={formik.handleChange}
                                            error={formik.touched.country && Boolean(formik.errors.country)}
                                            helperText={formik.touched.country && formik.errors.country}
                                            label={'Country*'} variant="outlined" sx={{width:'90%',  textAlign: 'left'}}>
                                            <MenuItem value={'United Kingdom'}>United Kingdom</MenuItem>
                                            <MenuItem value={'United States'}>United States</MenuItem>
                                        </TextField>
                                    </Grid>
                                    <Grid item xs={12}>
                                        <TextField
                                            label="Address*"
                                            sx={{width:"90%"}}
                                            name={'address'}
                                            value={formik.values.address}
                                            onChange={formik.handleChange}
                                            error={formik.touched.address && Boolean(formik.errors.address)}
                                            helperText={formik.touched.address && formik.errors.address}
                                        />
                                    </Grid>
                                    <Grid item xs={12}>
                                        <TextField
                                            label="Credit Card Number*"
                                            sx={{width:"90%"}}
                                            name={'cardNumber'}
                                            value={formik.values.cardNumber}
                                            onChange={formik.handleChange}
                                            error={formik.touched.cardNumber && Boolean(formik.errors.cardNumber)}
                                            helperText={formik.touched.cardNumber && formik.errors.cardNumber}
                                            type={"number"}
                                        />
                                    </Grid>

                                    <Grid item xs={12}>
                                        <TextField
                                            placeholder={"MM/YY"}
                                            label="Expiration Date*"
                                            sx={{width:"43%"}}
                                            name={'expirationDate'}
                                            value={formik.values.expirationDate}
                                            onChange={formik.handleChange}
                                            error={formik.touched.expirationDate && Boolean(formik.errors.expirationDate)}
                                            helperText={formik.touched.expirationDate && formik.errors.expirationDate}
                                        />&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                                        <TextField
                                            label="Security Code*"
                                            sx={{width:"45%"}}
                                            name={'securityCode'}
                                            value={formik.values.securityCode}
                                            onChange={formik.handleChange}
                                            error={formik.touched.securityCode && Boolean(formik.errors.securityCode)}
                                            helperText={formik.touched.securityCode && formik.errors.securityCode}
                                        />
                                    </Grid>
                                </Grid>

                            </Container>
                            <Container  maxWidth="lg"  component="main" sx={{  }}>

                                <Stack spacing={5} direction="row" sx={{
                                    display: 'flex',
                                    justifyContent: 'center',
                                    alignItems: 'center',
                                    mt:5,
                                    mb:5
                                }}>
                                    <Button variant="outlined" sx={{pt: 1.2, pb:1.2, pl: 5, pr:5, fontSize: '18px', textTransform:'uppercase'}}   onClick={() => navigator(-1)}>Go back</Button>

                                    <Button variant="contained" sx={{pt: 1.2, pb:1.2, pl: 5, pr:5, fontSize: '18px', textTransform:'uppercase'}}  type='submit'>
                                        Next
                                    </Button>
                                </Stack>
                            </Container>

                        </React.Fragment>
                    </Form>
                )
            }
        </Formik>

    )
}
export default MembershipPlanPaymentUSA;